module.exports = __webpack_public_path__ + "toBride1-we-y-b.b055c2f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-y-b.jpg
// module id = E03O
// module chunks = 0